import api from 'services/api';

export const recordUserLoginInformation = async () => {
  const response = await api('/users/record-login');

  return response;
};
